import { memberApiV2 } from '@lib/api';
import {
  IPendinActionsBase,
  IPendinActionsProfile,
  IPendingActionsOverview,
} from 'types/pendingActions.types';

export function getPendingActionsBase(providerId: string) {
  return memberApiV2.request<{ data: IPendinActionsBase }>(
    'management/private/pending-action/base',
    {
      method: 'GET',
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function getPendingActionsProfile(providerId: string) {
  return memberApiV2.request<{ data: IPendinActionsProfile }>(
    'management/private/pending-action/business-profile',
    {
      method: 'GET',
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function getPendingActionsOverview(providerId: string) {
  return memberApiV2.request<{ data: IPendingActionsOverview }>(
    'management/private/pending-action/overview',
    {
      method: 'GET',
      headers: {
        'provider-id': providerId,
      },
    },
  );
}
